export const LOAD_PERDIEM_REQUEST_APPROVALS = "LOAD_PERDIEM_REQUEST_APPROVALS"
export const loadPerdiemRequestApprovalsAction = pagination => ({
   type: LOAD_PERDIEM_REQUEST_APPROVALS,
   payload: pagination
})